import { CdkTreeModule } from '@angular/cdk/tree';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTreeModule } from '@angular/material/tree';

import { InputErrorModule } from '@app/modules/ui-components/components/input-error/input-error.module';
import { SelectTreeComponent } from '@app/modules/ui-components/components/select-tree/select-tree.component';

import { IconComponent } from '../icon/icon.component';

@NgModule({
  declarations: [SelectTreeComponent],
  imports: [
    CommonModule,
    CdkTreeModule,
    MatTreeModule,
    MatCheckboxModule,
    MatIconModule,
    InputErrorModule,
    MatMenuModule,
    MatInputModule,
    IconComponent,
  ],
  exports: [SelectTreeComponent],
})
export class SelectTreeModule {}
